import {
  ScaffolderFormHeader,
  ScaffolderFormPaper,
} from '@internal/plugin-scaffolder-common-field-react';
import React from 'react';

import { Box, Link } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

export const ProjectAllowedReposNotice = () => (
  <Box>
    <ScaffolderFormPaper>
      <ScaffolderFormHeader title="Allowed Repositories" divider />
      <Alert severity="info">
        Project repository URL allowlists are now centrally managed. You can use
        any repository whose URL matches one of the{' '}
        <Link
          href="https://github.com/tomtom-internal/deployment-as-a-service/blob/main/docs/tools/allowlist.md"
          target="_blank"
          rel="noreferrer"
        >
          allowed URL prefixes
        </Link>
        .
      </Alert>
    </ScaffolderFormPaper>
  </Box>
);
